module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_plan_included_04-435b828b34b6d8e553a64b4c8bec6367.png";